// Grids & Gantts — the marks of a clone.
//
// Three drawings, one job each:
//
//   DnaIcon      the small mark on a ROW. A DNA strand: it appears on hover
//                on a row whose type may be cloned, and STAYS on a row that
//                has been picked for cloning — so the picked rows can be
//                told from a plain selection at a glance.
//   CloneBanner  the picture on the DIALOG: two sheep and an arrow, the
//                client's own choice of joke. Dolly, twice.
//   CloneIcon    the single sheep, kept for anywhere a small sheep is wanted.
//
// All three are black and white on purpose: they read in either theme, and
// a sheep in the accent colour is not a sheep. `color` on the DNA strand is
// the one exception — a picked row's strand takes the page's blue.

// A helix on the diagonal, the way the client drew it: two backbones
// crossing twice, with the rungs between them, in the page's blue.
export function DnaIcon({ size = 14, title = 'Clone', color = '#3b8fd9', style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-label={title} role="img" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
      style={{ display: 'inline-block', verticalAlign: 'middle', flex: '0 0 auto', ...style }}>
      <title>{title}</title>
      <g transform="rotate(45 16 16)">
        {/* the two backbones */}
        <path d="M10 1.5c0 7 12 7.2 12 14.5S10 23.5 10 30.5" />
        <path d="M22 1.5c0 7-12 7.2-12 14.5s12 7.5 12 14.5" />
        {/* the rungs, longest where the strands are furthest apart */}
        <path d="M11.5 5h9" /><path d="M13.5 8.5h5" />
        <path d="M13.5 23.5h5" /><path d="M11.5 27h9" />
      </g>
    </svg>
  );
}

// One sheep, drawn once and used twice below.
const Sheep = ({ x = 0, stripes = false }) => (
  <g transform={`translate(${x} 0)`}>
    <path d="M14 8c1.6-3 5.8-3.8 8.4-1.8 2.3-2.5 7-2.3 8.9.7 3.4-.5 6.4 2.5 5.5 5.9 3 1.6 3 6.2 0 7.8.7 3.4-2.3 6.4-5.7 5.7-1.9 3-6.6 3.2-8.9.7-2.7 2-6.9 1.2-8.4-1.8-3.6.5-6.4-3-5-6.4C5.9 17 5.9 12.6 8.8 11.2c-.9-3.4 1.8-6.4 5.2-3.2z"
      fill="#fff" stroke="#15161a" strokeWidth="2" strokeLinejoin="round" />
    {stripes ? (
      <g fill="none" stroke="#15161a" strokeWidth="2.2" strokeLinecap="round" opacity="0.9">
        <path d="M18 8l-5 12" /><path d="M23 7l-6 15" /><path d="M28 8l-6 15" /><path d="M33 11l-5 12" />
      </g>
    ) : null}
    <rect x="15" y="25" width="3.4" height="7" rx="1.2" fill="#15161a" />
    <rect x="26" y="25" width="3.4" height="7" rx="1.2" fill="#15161a" />
    <ellipse cx="10" cy="17" rx="5.6" ry="6.2" fill="#15161a" />
    <circle cx="8" cy="15.6" r="1.5" fill="#fff" /><circle cx="12" cy="15.6" r="1.5" fill="#fff" />
    <circle cx="8.2" cy="15.8" r="0.7" fill="#15161a" /><circle cx="12.2" cy="15.8" r="0.7" fill="#15161a" />
    <path d="M5 13.5c-1.9-.7-2.3-2.8-1-3.7 1.4-1 3.2.2 3 2" fill="#15161a" />
  </g>
);

// Two sheep and an arrow: the client's own clone picture. The copy on the
// right wears the stripes, because it was made here.
export function CloneBanner({ height = 64, title = 'Clone', style }) {
  const w = Math.round(height * (104 / 36));
  return (
    <svg width={w} height={height} viewBox="0 0 104 36" aria-label={title} role="img" style={{ display: 'inline-block', flex: '0 0 auto', ...style }}>
      <title>{title}</title>
      <Sheep x={0} />
      <path d="M44 18h12m0 0l-4-4m4 4l-4 4" fill="none" stroke="#15161a" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
      <Sheep x={62} stripes />
    </svg>
  );
}

export default function CloneIcon({ size = 14, title = 'Clone', style }) {
  const h = Math.round(size * 0.9);
  return (
    <svg width={size} height={h} viewBox="4 4 36 30" aria-label={title} role="img" style={{ display: 'inline-block', verticalAlign: 'middle', flex: '0 0 auto', ...style }}>
      <title>{title}</title>
      <Sheep x={0} stripes />
    </svg>
  );
}
